module.exports = __webpack_public_path__ + "img/Mobile-Menu-Account-Icon-LoggedIn.87ee95c9.svg";